import { ArtificialProposalResponse } from 'v2/models';
import { SearchResponseItemProps } from '../../../SearchResponseItem';
import { SearchResponsesPerTab, SearchTab } from '../../../SearchResponses';
import { ResponsesListItem } from '../../types';
import {
  mapSearchToResponseListItem,
  mapArtificialProposalResponseToResponseListItem,
} from '../mappers';
import { sortResponsesListItemsByCreationDate } from '../sortResponsesListItemsByCreationDate';
import { sortSearchesByStatus } from '../sortSearchesByStatus';

type GetResponsesListItemsProps = {
  searchResponses: SearchResponsesPerTab;
  artificialProposalResponses: ArtificialProposalResponse[];
  tab: SearchTab;
};

export function getResponsesListItems({
  tab,
  artificialProposalResponses,
  searchResponses,
}: GetResponsesListItemsProps): ResponsesListItem[] {
  const tabSearches: SearchResponseItemProps[] = searchResponses[tab];

  switch (tab) {
    case 'all':
      return [
        ...sortSearchesByStatus(tabSearches).map(mapSearchToResponseListItem),
        ...artificialProposalResponses.map(
          mapArtificialProposalResponseToResponseListItem
        ),
      ];

    case 'accepted':
    case 'rejected':
      return sortResponsesListItemsByCreationDate(
        tabSearches.map(mapSearchToResponseListItem)
      );

    case 'new':
      return sortResponsesListItemsByCreationDate([
        ...tabSearches.map(mapSearchToResponseListItem),
        ...artificialProposalResponses.map(
          mapArtificialProposalResponseToResponseListItem
        ),
      ]);
  }

  return [];
}
